import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainPageComponent } from '../layout/main-page/main-page.component';
import { LogoutComponent } from './logout/logout.component';
import { BridgeComponent, LoginAuth0Component, LoginBackendComponent, TokenSecurityInitComponent } from 'common';

const routes: Routes = [
  {
    path: 'backend',
    component: MainPageComponent,
    children: [
      { path: 'init', component: TokenSecurityInitComponent },
      { path: 'login', component: LoginBackendComponent },
      { path: 'logout', component: LogoutComponent }
    ]
  },
  { path: 'login', component: LoginAuth0Component },
  { path: 'logout', component: LogoutComponent },
  { path: 'bridge', component: BridgeComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SecurityRoutingModule { }
